import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var Mouse = /** @class */ (function (_super) {
    __extends(Mouse, _super);
    function Mouse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Mouse, "cursor", {
        /*
         The name of the native cursor.
         */
        get: function () {
            return Mouse._cursor;
        },
        set: function (value) {
            Mouse._cursor = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Mouse, "supportsCursor", {
        /*
         [read-only] Indicates whether the computer or device displays a persistent cursor.
         */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Mouse, "supportsNativeCursor", {
        /*
         [read-only] Indicates whether the current configuration supports native cursors.
         */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    /*
     Hides the pointer.
     */
    Mouse.hide = function () {
    };
    /*
     Displays the pointer.
     */
    Mouse.show = function () {
    };
    /*
     Registers a native cursor under the given name, with the given data.
     */
    Mouse.registerCursor = function (name, cursor) {
    };
    /*
     Unregisters a native cursor under the given name, with the given data.
     */
    Mouse.unregisterCursor = function (name) {
    };
    return Mouse;
}(ASObject));
export { Mouse };
